<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Subcontractor Public Access Settings ['+subcontractor.subcontractor_name+'] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/qualification/view/${subcontractor.subcontractor_id}`">
                            {{ subcontractor.subcontractor_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-unlock"></i> Public Access
                    </li>
                </ol>
            </h4>

            <div class="row mb-3">
                <div class="col-xl-8 col-12">
                    <div class="card mb-3">
                        <div class="card-header"><i class="fa fa-cogs"></i> Settings</div>
                        <div class="card-body">
                            <div class="form-group row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.enable_public_access }">
                                    Enable Public Access:
                                </label>
                                <div class="col-md-6 col-sm-8">
                                    <b-form-checkbox v-model="subcontractor.enable_public_access" :value="1" :unchecked-value="0" plain />

                                    <span v-if="errors.enable_public_access" class="text-danger">
                                        <span v-for="error in errors.enable_public_access">{{ error }}</span>
                                    </span>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right text-muted': true, 'text-danger': errors.public_access_expires_at }">
                                    Public Access Expiration:
                                </label>
                                <div class="col-md-6 col-sm-8">
                                    <div class="input-group input-group-sm">
                                        <b-form-datepicker
                                                v-model="subcontractor.public_access_expires_at"
                                                :class="{'is-invalid': errors.public_access_expires_at}"
                                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                                size="sm" />

                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-default btn-sm" style="height: inherit;" v-on:click="() => { this.subcontractor.public_access_expires_at = null; }">
                                                <i class="fa fa-remove text-danger"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="text-info mb-1">
                                        Leave this field blank if the link that should never expire.
                                    </div>

                                    <span v-if="errors.public_access_expires_at" class="text-danger">
                                        <span v-for="error in errors.public_access_expires_at">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="button" v-on:click="saveSubcontractor()" :disabled="saving" class="btn btn-sm btn-success">
                        <template v-if="!saving">Update Public Access Settings</template>
                        <template v-else><i class="fa fa-spin fa-spinner"></i> Saving</template>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                errors: {},
                subcontractor: {},
                expires_at: null,
                start_time: null,
            }
        },

        methods: {
            //Gets the subcontractor
            getSubcontractor() {
                //Get the data
                this.$http
                    .get('subcontractors/public-access/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.subcontractor = response.data.subcontractor;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSubcontractor() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('subcontractors/public-access/' + this.subcontractor.subcontractor_id, this.subcontractor)
                .then(response => {
                    //Alert
                    this.$toastr.success('Public Access Settings Updated');

                    //Send back to the qualification view
                    this.$router.push('/subcontractors/qualification/view/'+this.subcontractor.subcontractor_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        },
    }
</script>
